const WHATSAPP_NUMBER = "5519996234059";

export function whatsappUrl(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export const WHATSAPP_DEFAULT = whatsappUrl(
  "Olá, Bruno! Vim pelo site da Ambitie e gostaria de solicitar um orçamento",
);

export const WHATSAPP_SYSTEM = whatsappUrl(
  "Olá, Bruno! Vim pelo site da Ambitie e quero conversar sobre um sistema sob medida",
);

export function whatsappTierUrl(tierName) {
  return whatsappUrl(`Olá, Bruno! Vim pelo site da Ambitie e quero um orçamento de: ${tierName}`);
}

// Single label for the "contact" intent, used by every CTA on the page. It says
// what the click gets and how fast; CTA_NOTE answers the remaining objection.
export const CTA_LABEL = "Receber orçamento hoje";
export const CTA_LABEL_SHORT = "Pedir orçamento";
export const CTA_NOTE = "Resposta no mesmo dia. Proposta sem compromisso.";

// ---------------------------------------------------------------------------
// Proof that only Bruno can supply. Every block below renders only when filled,
// so the page never shows invented results, reviews, guarantees or scarcity.
// ---------------------------------------------------------------------------

// Risk reversal shown next to the pricing and final CTAs.
// Example: { title: "Ajustes até você aprovar", text: "..." }
export const guarantee = null;

// Real, current capacity. Example: { month: "outubro", open: 2, total: 4 }
export const capacity = null;

// Client testimonials (not colleagues): real photo, company and result.
// Example: { name: "Julia", role: "Fundadora, Ny Julia Braids", photo: "/clientes/julia.webp",
//            quote: "...", result: "Agenda cheia 3 semanas antes" }
export const clientTestimonials = [];

export const stats = [
  { value: "251+", label: "clientes usam o Tô de Trança, sistema que criamos" },
  { value: "6+ anos", label: "construindo sistemas, inclusive hospitalares" },
  { value: "7 dias", label: "do escopo fechado ao site no ar" },
];

// `result` is a measured outcome shown as the case headline. Only fill with
// real numbers (e.g. "Agendamentos pelo site: 4 → 22 por mês").
export const cases = [
  {
    name: "Tô de Trança",
    url: "https://todetranca.app.br/",
    type: "Sistema e marketplace",
    summary:
      "Nasceu como solução personalizada para a Ny Julia Braids e virou produto próprio, vendido em todo o Brasil.",
    image: "/cases/todetranca.webp",
    fullImage: "/cases/todetranca-full.webp",
    result: "251+ clientes ativos",
    featured: true,
  },
  {
    name: "Atitude Som e Luz",
    url: "https://www.atitudesomeluz.com.br/",
    type: "Site institucional",
    summary: "Estrutura, precisão e capacidade técnica para fechar eventos maiores.",
    image: "/cases/atitude.webp",
    fullImage: "/cases/atitude-full.webp",
  },
  {
    name: "Ny Julia Braids",
    url: "https://www.nyjuliabraids.com.br/",
    type: "Site de marca",
    summary: "Estética premium e caminho curto até o agendamento.",
    image: "/cases/nyjulia.webp",
    fullImage: "/cases/nyjulia-full.webp",
  },
  {
    name: "Letícia Borges Jornalista",
    url: "https://portifolio-leticia-eta.vercel.app/",
    type: "Portfólio profissional",
    summary: "Editorial sóbrio que traduz credibilidade jornalística em cada seção.",
    image: "/cases/leticia.webp",
    fullImage: "/cases/leticia-full.webp",
  },
];

// Concept work for fictional clients, built to show a style. `demo` makes every
// card label it as such, so it is never presented as a client result.
const demos = [
  {
    name: "Kōhaku",
    url: "https://kohaku-site.vercel.app/",
    type: "Site de restaurante",
    summary:
      "Sushi bar inspirado no bushidō: clima noturno e reserva de mesa em destaque.",
    image: "/cases/kohaku.webp",
    fullImage: "/cases/kohaku-full.webp",
    demo: true,
  },
  {
    name: "Equus",
    url: "https://equus-five.vercel.app/",
    type: "Site institucional",
    summary:
      "Clínica veterinária de equinos: fotografia autoral, tom sereno e agendamento a um clique.",
    image: "/cases/equus.webp",
    fullImage: "/cases/equus-full.webp",
    demo: true,
  },
];

// Home page selection: the strongest real cases plus one demo for visual range.
const HOME_CASES = ["Tô de Trança", "Atitude Som e Luz", "Ny Julia Braids", "Kōhaku"];

// Everything shown on /projetos: the real cases first, then concept work.
export const projects = [...cases, ...demos];

export const homeCases = HOME_CASES.map((name) => projects.find((p) => p.name === name));

// Good / Better / Best on one axis (scope of the site). The institutional site is
// the plan we want to sell; custom systems anchor the top so it reads as cheap;
// the entry site lacks the pages a growing company needs, so it acts as decoy.
// Feature order follows the serial-position effect: core value first,
// comparison rows in the middle, differentiator last (closest to the CTA).
// RASCUNHO: confirmar escopo de cada plano e o piso do sistema antes do deploy.
export const pricingTiers = [
  {
    name: "Site profissional",
    price: "R$ 700",
    pricePrefix: "A partir de",
    description: "Para ser encontrado no Google e passar confiança no primeiro acesso.",
    delivery: "No ar em 7 dias",
    features: [
      "Uma página com as seções essenciais",
      "Botão direto para o seu WhatsApp",
      "Otimização básica para o Google",
      "Design sob medida, sem template",
    ],
  },
  {
    name: "Site institucional",
    price: "R$ 2.000",
    pricePrefix: "A partir de",
    description: "Para a empresa parecer do tamanho que é e fechar contratos maiores.",
    delivery: "No ar em 7 dias",
    featured: true,
    features: [
      "Páginas de serviços, sobre, cases e contato",
      "Tudo do Site profissional",
      "Otimização para o Google em cada página",
      "Textos organizados para vender contratos maiores",
    ],
  },
  {
    name: "Sistema sob medida",
    price: "R$ 15.000",
    pricePrefix: "A partir de",
    description: "Da ideia ao produto, como fizemos com o Tô de Trança.",
    delivery: "2 a 3 meses",
    system: true,
    features: [
      "Produto construído para a sua operação",
      "Área de clientes, agendamentos ou pagamentos",
      "Integrações com as ferramentas que você já usa",
      "Rigor de quem constrói sistemas hospitalares",
    ],
  },
];

export const included = [
  "Design sob medida, sem template",
  "Versão pensada para celular",
  "Botão direto para o seu WhatsApp",
  "Escopo e valor fechados antes de começar",
];

export const processSteps = [
  {
    title: "Você conta o objetivo",
    description:
      "Uma conversa no WhatsApp. Fazemos as perguntas certas para entender o que precisa ser construído.",
  },
  {
    title: "Recebe a proposta fechada",
    description: "Escopo, prazo e valor antes de começar. Sem surpresa no meio do caminho.",
  },
  {
    title: "Seu projeto entra no ar",
    description: "Sites em 7 dias. Sistemas sob medida em 2 a 3 meses, conforme a complexidade.",
  },
];

export const recommendationsUrl =
  "https://www.linkedin.com/in/bruno-luz-comunicacao-desenvolvimento-tecnologia/details/recommendations/";

export const recommendations = [
  {
    name: "Geisicler Rodrigues",
    role: "Coordenadora de Relacionamento Médico e Multiprofissional",
    quote:
      "…cria com facilidade, técnica e precisão, alcançando resultados incríveis no desenvolvimento de aplicações e integrações.",
  },
  {
    name: "Marcelo Pedroni da Silva",
    role: "Senior Data Engineer, CI&T",
    quote:
      "Bruno possui sólida competência técnica, contribuindo tanto para a parte de design e front-end quanto no desenvolvimento do back-end.",
  },
];
